import { UploadsPermissions } from './uploads.permissions';
import { UploadsRoles } from './uploads.roles';

export const uploadsMappings = {
  [UploadsPermissions.GET_UPLOADS]: [UploadsRoles.VIEWER],
  [UploadsPermissions.PERSIST_UPLOAD]: [UploadsRoles.PERSISTER],
  [UploadsPermissions.DELETE_UPLOAD]: [UploadsRoles.DELETER],
  [UploadsPermissions.BULK_EXPORT]: [UploadsRoles.BULK_EXPORTER],
};
